import { IStudioLibraryItem } from "./IStudioLibraryItem";
import { AssetType } from "@app/shared/models/assetType";

export class TextSymbol implements IStudioLibraryItem{
  id: number;
  uuid:string;
  name: string;
  type:AssetType;
  fontFamily?:string;
  fontSize?:string;
  fontWeight?:string;
  fontDecoration?:string;
  color?:string;
  fabricElem:any;
  targetField:string;
  svgSrc:string;
  jsonSrc:string;
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/pmclient-uat/src/app/shared/models/textSymbol.ts